import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
// @ts-ignore
import regenPodImage from '../../assets/Images/RegenPod.png';
// @ts-ignore
import keepClinicImage from '../../assets/Images/keep-clinic.jpg';
// @ts-ignore
import urbanHotelImage from '../../assets/Images/urban-hotel.webp';
import { TimeSlotSelector } from '../../components/TimeSlotSelector';
import '../../assets/styles/regenpod/regenpod-vip.css';

export const RegenPodVIP: React.FC = () => {
  const [formData, setFormData] = useState<any>({
    fullName: '',
    email: '',
    mobile: '',
    business: '',
    receiveUpdates: false,
    eventType: 'VIP',
  });
  
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isHotelExpanded, setIsHotelExpanded] = useState(false);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value, type } = e.target;
    const checked = (e.target as HTMLInputElement).checked;
    
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });
  };

  const handleTimeSlotChange = (slot: string) => {
    setFormData({
      ...formData,
      timeSlot: slot
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      await fetch('https://api.regenphd.com/regenpod-registration', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({...formData, isVIP: true})
      });
      setIsSubmitted(true);
      
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.get('fromList') === 'true') {
        window.location.href = 'https://app.regenphd.com/regenpod-vip-list';
      }
    } catch (error) {
      console.error('Registration failed:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>Regen PhD Pod Launch VIP Event | Experience the Future of Regenerative Wellness</title>
        <meta name="description" content="Join the exclusive VIP launch of the world's first Regen PhD Pod. Experience breakthrough regenerative wellness technology created by Professor Paul Lee." />
      </Helmet>
      
      <div className="regenpod-vip-container">
        <div className="regenpod-hero">
          <div className="regenpod-image-container">
            <img src={regenPodImage} alt="Regen PhD Pod" className="regenpod-device" />
          </div>
        </div>
        
        <div className="regenpod-content">
          <h1 className="regenpod-title font-medium text-center">
            <span className="font-bold font-xxlg">VIP</span>
            <br />
            REGEN PHD POD LAUNCH
          </h1>

          <p className="regenpod-subtitle font-regular text-center">
            First in the World. Experience the Future of<br />
            Regenerative Wellness.
          </p>

          <div className="event-details">
            <div className="event-info">
              <div className="event-date font-medium">
                <span className="date">8th NOV</span>
                <span className="year">2025</span>
                <span className="year">Saturday</span>
              </div>
              <div className="event-time font-medium">
                <span className="time">1:00 - 4:00 PM</span>
                <span className="dress-code text-uppercase">• Regenerative Science <br />• Pod Experience</span>
              </div>
              <div className="event-location font-medium">
                <span className="venue">THE KEEP CLINIC,</span>
                <span className="city">GRANTHAM</span>
                <div className="venue-image">
                  <img src={keepClinicImage} alt="The Keep Clinic" style={{width: '100%', maxWidth: '300px', borderRadius: '8px', marginTop: '10px'}} />
                </div>
              </div>
            </div>
          </div>

          <p className="event-description">
            Be among the first to experience the world's first Regen PhD Pod,<br />
            a breakthrough in regenerative wellness created by<br />
            Professor Paul Lee.
          </p>

          <div className="event-highlights">
            <div className="highlight">
              <div className="highlight-text">
                <span className="font-semibold">MEET PROFESSOR PAUL LEE.</span><br />
                EXPERIENCE LIVE MUSIC, BUBBLES<br />
                AND IMMERSIVE WELLNESS
              </div>
            </div>
            <div className="highlight">
              <div className="highlight-text">
                <span className="font-medium">EXPERIENCE THE REGEN PHD POD</span><br />
                IN PERSON
              </div>
            </div>
          </div>
        </div>

        <div className="hotel-accommodation-section">
          <div className="hotel-container">
            <h2 className="hotel-title font-semibold" onClick={() => setIsHotelExpanded(!isHotelExpanded)}>
              Hotel Accommodation
              <span className={`hotel-toggle-icon ${isHotelExpanded ? 'expanded' : ''}`}>▼</span>
            </h2>
            <div className={`hotel-content ${isHotelExpanded ? 'expanded' : 'collapsed'}`}>
              <div className="hotel-info">
                <div className="hotel-image">
                  <img src={urbanHotelImage} alt="The Urban Hotel Grantham" style={{width: '100%', maxWidth: '400px', borderRadius: '8px'}} />
                </div>
                <div className="hotel-details">
                  <h3 className="font-medium">The Urban Hotel Grantham</h3>
                  <p className="hotel-description">
                    Located in the heart of Grantham, The Urban Hotel offers comfortable accommodation 
                    just minutes away from The Keep Clinic event venue.
                  </p>
                  
                  <div className="hotel-code-section">
                    <div className="code-display">
                      <h4 className="font-bold" style={{fontSize: '2rem', textAlign: 'center', margin: '20px 0', color: '#2c5aa0'}}>REGENPARTY</h4>
                    </div>
                  </div>
                  
                  <div className="hotel-offer">
                    <div className="offer-badge">EXCLUSIVE DISCOUNT FOR EVENT GUESTS</div>
                    <div className="pricing">
                      <div className="price-item">
                        <span className="price">£58</span>
                        <span className="description">per room</span>
                      </div>
                      <div className="price-item">
                        <span className="price">£70</span>
                        <span className="description">with breakfast</span>
                      </div>
                    </div>
                  </div>
                  
                  <div className="booking-info">
                    <h4 className="font-semibold">How to Book:</h4>
                    <div className="booking-steps">
                      <div className="step"><span className="step-arrow">→</span> Call on number: <a href="tel:01476593000" className="contact-link font-semibold">01476 593000</a></div>
                      <div className="step"><span className="step-arrow">→</span> Say {" "} <strong> REGENPARTY </strong> {" "} code</div>
                      <div className="step"><span className="step-arrow">→</span> Book the hotel</div>
                    </div>
                    <div className="contact-details">
                      <div className="contact-item">
                        <span className="label">🌐 Website:</span>
                        <a href="https://www.urbanhotelgrantham.co.uk" target="_blank" rel="noopener noreferrer" className="contact-link">
                          urbanhotelgrantham.co.uk
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="registration-section">
          <div className="registration-container">
            <h2 className="font-semibold">
              <span className="font-bold font-xlg">VIP</span><br />Registration
            </h2>
            <p>Secure your exclusive invitation to this groundbreaking event</p>
            
            {isSubmitted ? (
              <div className="confirmation-message">
                <h3>Thank you!</h3>
                <p>Your place has been reserved — we'll be in touch with full event details soon.</p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="registration-form">
                <input
                  type="text"
                  name="fullName"
                  placeholder="Full Name *"
                  value={formData.fullName}
                  onChange={handleInputChange}
                  required
                />
                
                <input
                  type="email"
                  name="email"
                  placeholder="Email Address *"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                />
                
                <input
                  type="tel"
                  name="mobile"
                  placeholder="Mobile *"
                  value={formData.mobile}
                  onChange={handleInputChange}
                  required
                />
                
                <input
                  type="text"
                  name="business"
                  placeholder="Business / Organisation (optional)"
                  value={formData.business}
                  onChange={handleInputChange}
                />
                
                <TimeSlotSelector
                  startTime="13:30"
                  endTime="16:00"
                  eventType="VIP"
                  selectedSlot={formData.timeSlot}
                  onChange={handleTimeSlotChange}
                />
                
                <label className="checkbox-label">
                  <input
                    type="checkbox"
                    name="receiveUpdates"
                    checked={formData.receiveUpdates}
                    onChange={handleInputChange}
                  />
                  I'd like to receive updates about Regen PhD Pod events and innovations.
                </label>
                
                <input type="hidden" name="eventType" value="VIP" />
                
                <button type="submit" className="register-btn font-medium" disabled={isLoading}>
                  {isLoading ? 'REGISTERING...' : 'REGISTER FOR VIP ACCESS'}
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </>
  );
};